import {
  buildDocumentsTree,
  flattenDocumentTree,
} from '@cd3p/core/utils/documents';
import { State } from 'modules';
import { createSelector } from 'reselect';

export const termsAndConditions = (state: State) => state.termsAndConditions;
export const termsAndConditionsItems = (state: State) =>
  state.termsAndConditions.items;
export const termsAndConditionsItemsLoading = (state: State) =>
  state.termsAndConditions.loadTermsAndConditionsDocumentsPending;
export const termsAndConditionsItemsLoaded = (state: State) =>
  state.termsAndConditions.itemsLoaded;
export const termsAndConditionsItemsTree = (state: State) =>
  buildDocumentsTree(state.termsAndConditions.items);
export const termsAndConditionsSortedItems = createSelector(
  termsAndConditionsItemsTree,
  itemsTree => {
    return flattenDocumentTree(itemsTree);
  },
);
export const fetchTermsAndConditionsDocumentPending = (state: State) =>
  state.termsAndConditions.fetchTermsAndConditionsDocumentPending;
